import { render, staticRenderFns } from "./ExchangeFile.vue?vue&type=template&id=236ab411&scoped=true&"
import script from "./ExchangeFile.vue?vue&type=script&lang=js&"
export * from "./ExchangeFile.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeFile.vue?vue&type=style&index=0&id=236ab411&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236ab411",
  null
  
)

export default component.exports